import {
  LOGIN_USER,
  LOGOUT_USER,
  SET_GOOGLE_AUTH_STATUS
} from '../actions';

export const loginUser = () => ({
  type: LOGIN_USER,
});

export const logoutUser = () => ({
  type: LOGOUT_USER,
});

export const setGoogleAuthStatus = (payload) => ({
  type: SET_GOOGLE_AUTH_STATUS,
  payload,
});
